import { render, staticRenderFns } from "./InsuranceCriticismFormModal.vue?vue&type=template&id=1c375996&"
import script from "./InsuranceCriticismFormModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceCriticismFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports